const fontFamily = {
  Inter: 'Inter, Inter-Regular, Lato, Inter-Bold',
  Sora: 'Sora, Lato',
}

export default fontFamily
